import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="table-row"
export default class extends Controller {
  static values = { url: String }

  connect() {
    console.log("Table row controller connected to:", this.element)
  }

  visit(event) {
    console.log("Table row clicked. Target:", event.target)
    // Don't navigate if clicking a link or button inside the row
    if (event.target.closest('a') || event.target.closest('button')) {
      console.log("Click ignored: within link or button")
      return
    }

    if (this.hasUrlValue) {
      console.log("Navigating to:", this.urlValue)
      window.location.href = this.urlValue
    } else {
      console.log("Navigation failed: No URL value found")
    }
  }
}
